<template>
  <v-layout
    :title="$t('payment_help.title')"
    :subtitle="$t('payment_help.subtitle')"
  >
    <HelpPage :topics="topics" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import HelpPage from "@/components/HelpPage";

export default {
  components: {
    VLayout,
    HelpPage,
  },
  computed: {
    topics() {
      return [
        {
          title: this.$t("payment_help.methods.title"),
          text: this.$t("payment_help.methods.content"),
        },
        {
          title: this.$t("payment_help.safe.title"),
          text: this.$t("payment_help.safe.content"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        payment_help: {
          title: "How does payment options work?",
          subtitle: "Vooy Market is based on security and protection",
          breadcrumb: "Payment methods",
          methods: {
            title: "Payment methods",
            content: "",
          },
          safe: {
            title: "Safe payment",
            content: "",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
